import OverlayTips from "../OverlayTips";

function EnterTTPageOverlayTipsManager(isWholeWeekDisabled)
{
    PageOverlayTipsManager.call(this);
    this.isWholeWeekDisabled = isWholeWeekDisabled;
}

EnterTTPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        if (!this.isWholeWeekDisabled)
        {
            this.add($(".taskSearchField"), {
                messageKey: "tips.enter_tt.add",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetY: 10,
                outside: {
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: -100
                }
            });
        }

        this.add(function() { return $(".weekApprovalStatusControlOuterContainer.top").has(".notReady.showSwitcher").first() }, {
            messageKey: "tips.enter_tt.approve",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: -30,
            offsetY: -20
        });

        this.add($(".leaveButton").not(".disabled").eqOrLast(3), {
            messageKey: "tips.enter_tt.leave",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -20,
            offsetY: -5
        });

        this.add($("#actualTTRows").find(".inputTTContaner").first(), {
            messageKey: "tips.enter_tt.tt",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: -20
        });
    }
});

export default EnterTTPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/EnterTTPageOverlayTipsManager.js